import { render, staticRenderFns } from "./settlementProcess.vue?vue&type=template&id=5bfac3f4&scoped=true&"
import script from "./settlementProcess.vue?vue&type=script&lang=js&"
export * from "./settlementProcess.vue?vue&type=script&lang=js&"
import style0 from "./settlementProcess.vue?vue&type=style&index=0&id=5bfac3f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfac3f4",
  null
  
)

export default component.exports